import React from 'react';
import {Select} from 'antd';
const Option = Select.Option;

 const BusinessOverviewYearDropdown = (props) => {

  const businessOverviewTypeChange = (value) => {
    props.businessOverviewTypeChange(value);
  };

  return (
    <Select size="large" style={{ width: 300 }}
      className="overview type"
      value={props.type}
      onChange={value => businessOverviewTypeChange(value)}
      >
      {
        props.types.length === 0 ? 
        (<Option value="Type">Total</Option>) : 
        ( props.types.map((item, index) => {
          return <Option key={index} value={item.type}>{item.type}</Option>
        }))
      }
    </Select>
  )
  
}
export default BusinessOverviewYearDropdown



// WEBPACK FOOTER //
// ./src/components/economicProfile/BusinessOverviewTypeDropdown.js